module.exports = __webpack_public_path__ + "img/marisa kirisame lunar war enchanter_sc1.a8fb3b5a.png";